export const actionSymbol = '$_a';
export const actionOnSymbol = '$_aO';
export const computedSymbol = '$_c';
export const effectOnSymbol = '$_e';
export const persistSymbol = '$_p';
export const reducerSymbol = '$_r';
export const thunkOnSymbol = '$_tO';
export const thunkSymbol = '$_t';
